/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CarePrincipalDTO
 */
export interface CarePrincipalDTO {
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CarePrincipalDTO
     */
    email?: string;
}

export function CarePrincipalDTOFromJSON(json: any): CarePrincipalDTO {
    return CarePrincipalDTOFromJSONTyped(json, false);
}

export function CarePrincipalDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarePrincipalDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function CarePrincipalDTOToJSON(value?: CarePrincipalDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'email': value.email,
    };
}

